import { Nullable } from "web/types/Utils";

const addObjectFallback = <T>(object?: Nullable<T>) => {
  return object || ({} as Partial<T>);
};

export default addObjectFallback;
